import { gql } from 'apollo-boost';

const GET_CV_COMPANIES = gql`
  query {
    getCVCompanies {
      id
      name
      internName
      internCode
    }
  }
`;

const GET_COMPANY_PORTAL_DATA = gql`
  query ($alias: String!) {
    getCompanyPortalData(alias: $alias) {
      id
      logo
      name
      portalType
    }
  }
`;

const GET_STATES_OF_COMPANY = gql`
  query ($companyId: ID!) {
    getCompanyStates(companyId: $companyId) {
      state {
        id
        name
      }
    }
  }
`;

const CREATE_COMPANY_FROM_AMAZON_OB = gql`
  mutation (
    $slug: String!
    $recaptchaToken: String!
    $client: String!
    $key: String!
    $razonSocial: String!
    $regimenFiscal: String!
    $street: String!
    $streetNumber: String!
    $cp: String!
  ) {
    createCompanyFromAmazonOB(
      slug: $slug
      recaptchaToken: $recaptchaToken
      client: $client
      key: $key
      razonSocial: $razonSocial
      regimenFiscal: $regimenFiscal
      street: $street
      streetNumber: $streetNumber
      cp: $cp
    ) {
      fiscalData {
        rfc
        businessName
        fiscalRegimeCode
        address {
          cp
        }
        CSD {
          hasCsd
          verified
        }
      }
    }
  }
`;

const UPLOAD_CSD_FROM_AMAZON_OB = gql`
  mutation (
    $csdCert: String!
    $csdKey: String!
    $csdKeyPass: String!
    $rfc: String!
  ) {
    uploadCSDFilesFromAmazonOB(
      csdCert: $csdCert
      csdKey: $csdKey
      csdKeyPass: $csdKeyPass
      rfc: $rfc
    ) {
      id
    }
  }
`;

const UPLOAD_FIEL_FROM_AMAZON_OB = gql`
  mutation (
    $fielCert: String!
    $fielKey: String!
    $fielKeyPass: String!
    $rfc: String!
  ) {
    uploadFIELFilesFromAmazonOB(
      fielCert: $fielCert
      fielKey: $fielKey
      fielKeyPass: $fielKeyPass
      rfc: $rfc
    ) {
      id
    }
  }
`;

const UPLOAD_FIEL_FROM_AMAZON_OB_2 = gql`
  mutation (
    $fielCert: String!
    $fielKey: String!
    $fielKeyPass: String!
    $rfc: String
  ) {
    uploadFIELFilesFromAmazonOB2(
      fielCert: $fielCert
      fielKey: $fielKey
      fielKeyPass: $fielKeyPass
      rfc: $rfc
    ) {
      id
    }
  }
`;

const UPLOAD_CSD_FILES = gql`
  mutation (
    $cerBase64: String!
    $keyBase64: String!
    $keyPass: String!
    $rfc: String!
  ) {
    uploadCSDFiles(
      cerBase64: $cerBase64
      keyBase64: $keyBase64
      keyPass: $keyPass
      rfc: $rfc
    )
  }
`;

const ADD_OR_UPDATE_CER_FILES = gql`
  mutation (
    $cerType: String!
    $cerBase64: String!
    $keyBase64: String!
    $keyPass: String!
    $rfc: String!
  ) {
    addOrUpdateCerFiles(
      cerType: $cerType
      cerBase64: $cerBase64
      keyBase64: $keyBase64
      keyPass: $keyPass
      rfc: $rfc
    )
  }
`;

export {
  GET_CV_COMPANIES,
  GET_COMPANY_PORTAL_DATA,
  GET_STATES_OF_COMPANY,
  CREATE_COMPANY_FROM_AMAZON_OB,
  UPLOAD_CSD_FROM_AMAZON_OB,
  UPLOAD_FIEL_FROM_AMAZON_OB,
  UPLOAD_FIEL_FROM_AMAZON_OB_2,
  UPLOAD_CSD_FILES,
  ADD_OR_UPDATE_CER_FILES,
};
